<template>
  <span class="tag" :class="colorClass"><slot></slot></span>
</template>

<style scoped lang="scss">
  .tag {
    display: inline-block;
    margin-right: 10px;
    padding: 0.5em 0.75em;
    border-radius: 4px;

    font-size: var(--small);
    color: rgb(var(--white));

    &--blue {
      background-color: rgba(var(--blue-0), 0.7);
    }

    &--red {
      background-color: rgba(var(--red-0), 0.7);
    }
  }
</style>

<script>
  export default {
    name: 'Tag',

    components: {

    },

    props: {
      color: {
        type: String,
        default: 'blue'
      }
    },

    computed: {
      colorClass () {
        return `tag--${ this.color }`;
      }
    }
  };
</script>